import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import AddUpliftRatesToIndexMutation from '@/graphql/contracts/addUpliftRatesToIndex.mutation.gql';
import GetUpliftIndexesQuery from '@/graphql/contracts/getUpliftIndexes.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { GetUpliftIndexesVariables } from '@/graphql/contracts/_generated_/getUpliftIndexes.query';
import {
  AddUpliftRatesToIndex,
  AddUpliftRatesToIndexVariables
} from '@/graphql/contracts/_generated_/addUpliftRatesToIndex.mutation';

export const useAddUpliftRatesToIndex = (refetchVars: GetUpliftIndexesVariables) => {
  return useMutation<AddUpliftRatesToIndex, AddUpliftRatesToIndexVariables>(AddUpliftRatesToIndexMutation, {
    client: apolloClientContracts,
    refetchQueries: [{
      query: GetUpliftIndexesQuery,
      variables: refetchVars,
    }],
    onError: (err) => notificationService.open({ title: 'Error', text: err.message, type: 'danger' }),
  });
};
